const normalizeName = (name) =>
  name.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

const filterList = (villagers, value) =>
  villagers.filter((villager) => {
    const majValue = normalizeName(value.toUpperCase());
    const majName = normalizeName(
      villager.name.fr.toUpperCase() + villager.name.en.toUpperCase(),
    );
    return majName.includes(majValue);
  });

const filterVillagerList = (setFilteredList, villagers, event) => {
  const { value } = event.target;
  if (value !== '') {
    const TheFilteredList = filterList(villagers, value);
    setFilteredList(TheFilteredList);
  } else {
    setFilteredList(villagers);
  }
};

export default filterVillagerList;
